import CallToAction from 'components/contentBlocks/CallToAction';
import CallToActionColumn from 'components/contentBlocks/CallToActionColumn';
import PropTypes from 'prop-types';
import React from 'react';
import activeSetting from 'libs/wordpress/utils/activeSetting';
import colors from 'config/theme/colors';
import decodeHTMLEntities from '@nwg/core-web/utils/decodeHTMLEntities';
import { mediaQueries } from 'config/theme/breakpoints';
import ratios from 'config/theme/ratios';
import transformButtons from 'libs/wordpress/utils/transformButtons';
import transformFlexibleBackground from 'libs/wordpress/utils/transformFlexibleBackground';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

// Pure CMS data transformation before we send it to the "real" block!
const CallToActionBlock = ({ content = {}, isColumn = false, moduleTextColor = '' }) => {
    const { background_media_flexible: backgroundFlexible, buttons, heading, paragraph, settings, tag } = content;

    // Transform background data
    const hideBackground = activeSetting(settings, 'hide_background');
    const isAboveSm = useAboveBreakpoint('sm');

    let transformedBackground;
    let background;
    let backgroundType;

    if (!hideBackground) {
        transformedBackground = transformFlexibleBackground(backgroundFlexible);
        background = isAboveSm ? transformedBackground?.desktop : transformedBackground?.mobile;
        backgroundType = isAboveSm ? transformedBackground?.desktop?.type : transformedBackground?.mobile?.type;
    }

    // Transform color data
    const lightTheme = moduleTextColor === 'white';
    const textColor = lightTheme ? colors.white : colors.black;
    const buttonTheme = lightTheme ? 'outlinedWhite' : 'outlinedBlack';

    if (isColumn) {
        return (
            <CallToActionColumn
                background={background}
                backgroundRatio={[ratios.horizontal, ratios.vertical]}
                backgroundType={backgroundType}
                buttons={buttons ? transformButtons(buttons, { theme: buttonTheme }) : null}
                heading={heading ? decodeHTMLEntities(heading.text) : null}
                headingSize="lg"
                headingTag={heading ? heading.type : null}
                mediaQuery={mediaQueries.maxWidth}
                tag={decodeHTMLEntities(tag)}
                text={paragraph}
                textColor={textColor}
            />
        );
    }

    return (
        <CallToAction
            background={background}
            backgroundRatio={[ratios.vertical, ratios.square, ratios.horizontal]}
            backgroundType={backgroundType}
            buttons={buttons ? transformButtons(buttons, { theme: buttonTheme }) : null}
            heading={heading ? heading.text : null}
            headingSize="lg"
            headingTag={heading ? heading.type : null}
            mediaQuery={mediaQueries.maxWidth}
            tag={tag}
            text={paragraph}
            textColor={textColor}
        />
    );
};

CallToActionBlock.propTypes = {
    content: PropTypes.shape({
        'background_media_flexible': PropTypes.exact({
            mobile: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
            desktop: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object])),
        }).isRequired,
        buttons: PropTypes.arrayOf(PropTypes.object),
        heading: PropTypes.object,
        tag: PropTypes.string,
        paragraph: wysiwygProp,
    }),
    isColumn: PropTypes.bool,
    moduleTextColor: PropTypes.string,
};

export default CallToActionBlock;
